import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfilPageComponentComponent } from './perfil-page-component/perfil-page-component.component';
import { MaterialAngularModule } from '../material-design/material.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AtualizarPerfilModalComponent } from './atualizar-perfil-modal/atualizar-perfil-modal.component';
import { ConfirmarTokenFormComponent } from './confirmar-token-form/confirmar-token-form.component';
import { SharedPipesModule } from '../shared/pipes/shared-pipes.module';
import { SharedDirectivesModule } from '../shared/directives/shared-directives.module';
import { SelecaoCanalValidacaoPageComponent } from './selecao-canal-validacao-page/selecao-canal-validacao-page.component';
import { ComponentsModule } from '../shared/components/components.module';
import { RouterModule } from '@angular/router';
import { AlterarSenhaPerfilPageComponent } from './alterar-senha-perfil-page/alterar-senha-perfil-page.component';
import { ProfileTokenConfirmationPageComponent } from './profile-token-confirmation-page/profile-token-confirmation-page.component';
import { PasswordRecoveryModule } from '../password-recovery/password-recovery.module';
import { AccountConfirmationPageComponent } from './account-confirmation-page/account-confirmation-page.component';

@NgModule({
  declarations: [
    PerfilPageComponentComponent,
    AtualizarPerfilModalComponent,
    ConfirmarTokenFormComponent,
    SelecaoCanalValidacaoPageComponent,
    AlterarSenhaPerfilPageComponent,
    ProfileTokenConfirmationPageComponent,
    AccountConfirmationPageComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    MaterialAngularModule,
    FormsModule,
    SharedPipesModule,
    SharedDirectivesModule,
    ComponentsModule,
    RouterModule,
    ReactiveFormsModule,
    PasswordRecoveryModule,
  ]
})
export class PerfilModule { }
